import { render, staticRenderFns } from "./TitleAndManipulate.vue?vue&type=template&id=743ccc74&scoped=true&"
import script from "./TitleAndManipulate.vue?vue&type=script&lang=ts&"
export * from "./TitleAndManipulate.vue?vue&type=script&lang=ts&"
import style0 from "./TitleAndManipulate.vue?vue&type=style&index=0&id=743ccc74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743ccc74",
  null
  
)

export default component.exports